// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import newsletterSendEntity from './entities/newsletter-send.json';
import newsletterSendMenu from '../pages/newsletter-send/menu.json';
import newsletterSendFullForm from '../pages/newsletter-send/forms/full.json';
import newsletterSendContextForm from '../pages/newsletter-send/forms/context.json';
import newsletterSendMiniForm from '../pages/newsletter-send/forms/mini.json';
import newsletterSendLookupForm from '../pages/newsletter-send/forms/lookup.json';
import newsletterSendTableView from '../pages/newsletter-send/views/table.json';
import newsletterSendCardsView from '../pages/newsletter-send/views/cards.json';
import newsletterSendDashboardView from '../pages/newsletter-send/views/dashboard.json';

/** Тип запису «Розсилання» зі сторінками пакета: меню, форми та подання з pages/newsletter-send/. */
export const newsletterSendDefinition: IRecordTypeDefinition = {
  ...newsletterSendEntity,
  views: assembleViewSet({
      table: newsletterSendTableView,
      cards: newsletterSendCardsView,
      dashboard: newsletterSendDashboardView,
  }),
  form: newsletterSendFullForm,
  forms: { full: newsletterSendFullForm, context: newsletterSendContextForm, mini: newsletterSendMiniForm, lookup: newsletterSendLookupForm },
  menu: newsletterSendMenu,
} as IRecordTypeDefinition;
